/**
 * @packageDocumentation
 * @module      UserDetails.ts
 * @description Encapsulates data about a user.
 * @copyright  Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
/**
 * Encapsulates data about a user.
 */
export default class UserDetails {
    constructor() {
        /** The email (e.g., JDoe@siemens-healthineers.com). */
        this.username = "";
        /** The user's name */
        this.name = "";
        /* Used only for field systems, which are also "users" of the Cloud API. */
        this.password = null;
        this.roles = [];
        this.settings = new Settings();
    }
    hasRole(roleName) {
        return this.roles.some((r) => r.roleName === roleName);
    }
    setRole(roleName, grant) {
        if (grant) {
            if (!this.hasRole(roleName)) {
                this.roles.push(new Role(roleName));
            }
        }
        else {
            const ix = this.roles.findIndex((r) => r.roleName == roleName);
            if (ix >= 0) {
                this.roles.splice(ix, 1);
            }
        }
    }
    /**
     *  The systemId for a user's dedicated system is not part of this class. If the user
     *  is a dedicated device principal, the SystemController (on the server) will fill in the
     *  systemId when creating or updating the user. Such user maintenance for device principals
     *  must therefore be done through the SystemController. Adding or deleting human principals
     *  can be done by calling the UserController's methods.
     */
    toJSON() {
        return Object.assign({}, this);
    }
    static fromJSON(json) {
        let user = new UserDetails();
        const jsonKeys = Object.getOwnPropertyNames(json);
        jsonKeys.forEach((key) => {
            if (!user.hasOwnProperty(key)) {
                delete json[key];
            }
        });
        Object.assign(user, json);
        if (!user.roles) {
            user.roles = [];
        }
        return user;
    }
}
/**
 * Contains each setting as a property.
 * Expand this class if more settings are added.
 */
export class Settings {
}
export class Role {
    constructor(roleName) {
        this.roleName = '';
        this.roleName = roleName;
    }
}
export var RoleName;
(function (RoleName) {
    RoleName["RoboticNetworkAdmin"] = "ROBOTIC_NETWORK_ADMIN";
    RoleName["Audit"] = "AUDIT";
    RoleName["Api"] = "API";
})(RoleName || (RoleName = {}));
//# sourceMappingURL=UserDetails.js.map